// Author https://github.com/yegor-sytnyk/articles-list

export default [
  {
    id: 30659,
    date: "01.07.2021",
    status: "Solved",
    content: "Alec Baldwin, Geena Davis, Annie McEnroe, Maurice Page",
  },
  {
    id: 26597,
    date: "01.07.2021",
    status: "Pending",
    content: "Richard Gere, Gregory Hines, Diane Lane, Lonette McKee",
  },
  {
    id: 41263,
    date: "01.07.2021",
    status: "Pending",
    content: "Tim Robbins, Morgan Freeman, Bob Gunton, William Sadler",
  },
  {
    id: 2649,
    date: "01.07.2021",
    status: "Solved",
    content: "Paul Hogan, Linda Kozlowski, John Meillon, David Gulpilil",
  },
  {
    id: 10887,
    date: "01.07.2021",
    status: "Pending",
    content: "Tom Cruise, Kenneth Branagh, Bill Nighy, Tom Wilkinson",
  },
];
